import React from 'react';
import moment from 'moment';
import LetterHistory from 'modules/letter-history';
import LetterInformation from 'modules/letter-information';
import { Link, browserHistory } from 'react-router';
import { msg } from 'constants/message';
import { connect } from 'react-redux';
import { Letter, LetterProcessingWorkFlow, GiaiQuyetDonThu, Danhmuc, Reception } from 'api';
import { Toastr } from 'modules/toastr';
import { ShowIf } from 'components/utils';
import { FormXuLyHoacGiaiQuyet } from 'modules/handle-letters/xu-ly-don';
import { API_URL } from 'constants/config';
import ButtonGroup from 'modules/handle-letters/button-group';
import { CheckQuyenThaoTacXuLy } from 'modules/login/CheckQuyenThaoTacXuLy';
import { CheckViewPermission } from 'modules/login/CheckPermission';
import { GetTrangThaiDonTheoDonVi } from 'modules/login/GetTrangThaiDonTheoDonVi';
import {KetQuaXuLyDon} from 'modules/giai-quyet-don/subView';
import {
  NhiemVuTTXM
} from 'modules/handle-letters/xu-ly-don/form-giai-quyet';
import {
  ThongTinYeuCauKTDX
} from 'modules/handle-letters/xu-ly-don/form-kiem-tra-de-xuat';
import { CheckQuyenTuXuLy } from 'modules/login/CheckQuyenTuXuLy';
import { ConvertParams } from 'modules/handle-letters/xu-ly-don/ParamsGiaiQuyetDon.jsx';
import { ConfirmDialog } from 'modules/dialog';
import { TuGiaiQuyetDon } from 'modules/giai-quyet-don';
import {MasterLayout} from 'layout';
import {Loading} from 'modules/loading';
import { get, isEmpty } from 'lodash';

class HandleLettersDetails extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      btnLoading: false,
      btnSaveLoading: false,
      pageLoading: false,
      // URL param
      typePage: this.props.params.typePage,
      donDangXuLy: (this.props.params.trangThaiDon == 'dang' ? true : false),

      title: '',
      huongXuLy: '',
      donId: this.props.params.id,
      alias: '',
      listNextStates: [],
      params: [],
      data: [],
      processTypeValue: '',
      thongTinXuLyGiaiQuyet: {},

      // Thong tin don
      ma: '',
      ngayTiepNhan: '',

      // Trang thai don
      trangThaiDonDonVi: [],

      // Thong tin nguoi xu ly
      canBoDangXuLy: [],

      // Thong tin nguoi dung don
      loaiNguoiDungDon: '',
      dataNguoiDungDon: [],
      dataDoanDiCung: [],

      // Thong tin nguoi duoc uy quyen
      coUyQuyen: false,
      dataNguoiDuocUyQuyen: [],
      listTepUyQuyen: [],
      luatSu: false,
      listTepChungChiHanhNghe: [],

      // ThongTinDonVuViec
      nguonDon: '',
      noiDung: '',
      loaiDon: '',
      loaiDoiTuong: '',
      linhVuc: '',
      linhVucChiTiet: '',
      linhVucChiTietSub: '',
      linhVucChiTietKhac: '',
      // Tai lieu kem theo
      listTaiLieuVanThu: [],
      listTaiLieuBangChung: [],
      listTaiLieuVanThuKiemTraDeXuat: [],
      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],
      listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView: [],

      listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: [],
      listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: [],
      listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: [],
      listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: [],

      // Thong tin co quan dang giai quyet
      coThongTinCoQuanDangGiaiQuyet: false,
      dataCoQuanDangGiaiQuyet: {},

      // Thong tin co quan da giai quyet
      coThongTinCoQuanDaGiaiQuyet: false,
      dataCoQuanDaGiaiQuyet: {},
      lanhDaoDuyet: true,

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      initTaiLieuVanThu: [],

      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],

      loaiTepDinhKem: '',
      loaiQuyTrinh: '',
      tongSoLuotTCD: '',

      // Thong tin giai quyet don cua don
      thongTinGiaiQuyetDonId: '',
      thongTinGiaiQuyetDonPlus: {},

      // Danh sach tai lieu giai quyet don sau khi ttxm
      listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM: [],
      dataKetQuaXuLyDon: {},

      noticeMsg: '',
      backConfirm: false,
      dialogConfirm: false,
      dialogConfirmContent: '',
      hasChange: false,
      openConfirmDialog: false,
      isSave: false,
      displayXuLyDon: true,
      thoiHanBaoCaoKetQuaTTXM: '',
    }
  }

  componentDidMount() {
    this.getDetail(this.props.params.id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.id != this.props.params.id) {
      this.getDetail(nextProps.params.id);
      this.setState({donDangXuLy: nextProps.params.trangThaiDon == 'dang' ? true : false });
    }
  }

  getTrangThaiDonHienTai(donId, processType) {
    // Letter.actions.getTrangThaiDon.request({id: donId}, {quyTrinh: processType}).then(res => {
    //   if (res.data) {
    //     this.setState({donDangXuLy: res.data.trangThaiDon == 'DANG_XU_LY' ? true : false});
    //   }
      this.renderForm(donId);
    // });
  }

  onClickClose() {
    if (this.props.route.name == 'theodoi') {
      browserHistory.push('/theo-doi-thuc-hien-giai-quyet-don');
    } else {
      browserHistory.goBack();
    }
    this.props.dispatch({
      type: 'REFRESH_MENU',
      value: true
    });
  }

  // Gan du lieu xu ly don hoac giai quyet don
  handleDataForm(state) {
    let noticeMsg = state.notice;
    delete state.messege;

    this.setState({
      params: state,
      noticeMsg: noticeMsg,
      hasChange: true
    })
  }

  handleInitForm(state) {

    let noticeMsg = state.notice;
    delete state.messege;

    this.setState({
      params: state,
      noticeMsg: noticeMsg
    })
  }

  // An hien Qua Trinh Xu Ly
  hiddenLetterHistory(value) {
    this.setState({
      showHistory: value
    })
  }

  getDonInfo(donData) {
    Reception.actions.getDonInfo.request({ id: donData.donId }).then(res => {
      if (res.data) {
        donData = {...donData, ...res.data};
      }
      this.getTrangThaiDonHienTai(donData.donId, donData.processType);
      this.setState({

        data: donData,

        // Quyen tu xu ly
        quyenTuXuLy: donData.quyenTuXuLyInfo,

        // Dinh chi
        lyDoDinhChi: donData.lyDoDinhChi ? donData.lyDoDinhChi : '',

        // Thong tin nguoi xu ly
        canBoDangXuLy: donData.canBoDangXuLyInfo,

        // Thong tin don
        ma: donData.ma,
        trangThaiDonDonVi: GetTrangThaiDonTheoDonVi(donData.trangThaiDonInfo),
        ngayTiepNhan: donData.ngayTiepNhan,

        // Thong tin nguoi dung don
        loaiNguoiDungDon: donData.loaiNguoiDungDon ? donData.loaiNguoiDungDon : '',
        dataNguoiDungDon: donData.listNguoiDungDon ? donData.listNguoiDungDon : [],
        dataDoanDiCung: donData.loaiNguoiDungDon == 'DOAN_DONG_NGUOI' ? (donData.listDoanDiCung ? donData.listDoanDiCung : []) : [],

        // Thong tin nguoi duoc uy quyen
        coUyQuyen: donData.coUyQuyen,
        dataNguoiDuocUyQuyen: donData.coUyQuyen ? donData.nguoiDuocUyQuyen : [],

        luatSu: (donData.coUyQuyen && donData.nguoiDuocUyQuyen) ? (donData.nguoiDuocUyQuyen.luatSu) : false,

        // ThongTinDonVuViec
        loaiDonGiaTri: donData.loaiDon ? donData.loaiDon : '',
        tongSoLuotTCD: donData.tongSoLuotTCD ? donData.tongSoLuotTCD : '',
        nguonDon: donData.nguonDonText ? donData.nguonDonText : '',
        noiDung: donData.noiDung ? donData.noiDung : '',
        loaiDon: donData.loaiDonText ? donData.loaiDonText : '',
        loaiDoiTuong: donData.loaiDoiTuongInfo ? donData.loaiDoiTuongInfo : '',
        linhVuc: donData.linhVucDonThuDon ? donData.linhVucDonThuDon.ten : '',
        linhVucChiTiet: (donData.linhVucDonThuDon && donData.linhVucDonThuChiTietDon) ? donData.linhVucDonThuChiTietDon.ten : '',
        linhVucChiTietSub: (donData.linhVucDonThuDon && donData.linhVucDonThuChiTietDon && donData.chiTietLinhVucDonThuChiTietDon) ? donData.chiTietLinhVucDonThuChiTietDon.ten : '',
        linhVucChiTietKhac: (donData.linhVucChiTietKhac ? donData.linhVucChiTietKhac : ''),
        // Tai lieu kem theo
        // HuongXuLy.jsx
        listTaiLieuVanThu: donData.listTaiLieuVanThu ? donData.listTaiLieuVanThu : [],
        initTaiLieuVanThu: donData.listTaiLieuVanThu ? donData.listTaiLieuVanThu : [],
        listTaiLieuVanThuBlockCoQuanDaGiaiQuyet: donData.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet ? donData.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet : [],
        // form-giai-quyet
        listTaiLieuVanThuGiaiQuyetDon: donData.listTaiLieuVanThuGiaiQuyetDon ? donData.listTaiLieuVanThuGiaiQuyetDon : [],
        listTaiLieuVanThuGiaiQuyetDonView: donData.listTaiLieuVanThuGiaiQuyetDonView || [],
        listTaiLieuBangChung: [...donData.listTaiLieuBangChung, ...donData.listTaiLieuBangChungLuatSu],
        listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM: donData.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM || [],
        listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ: donData.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ || [],
        listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra: donData.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra || [],
        listTaiLieuVanThuGiaiQuyetDonGiaHanGQ: donData.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ || [],
        // TrinhLanhDaoView
        listTaiLieuVanThuChuyenDonBoSungHoSo: donData.listTaiLieuVanThuChuyenDonBoSungHoSo || [],
        // form-kiem-tra-de-xuat
        listTaiLieuVanThuKiemTraDeXuat: donData.listTaiLieuVanThuKiemTraDeXuat ? donData.listTaiLieuVanThuKiemTraDeXuat : [],

        listTaiLieuVanThuBoSungHoSo: donData.listTaiLieuVanThuBoSungHoSo ? donData.listTaiLieuVanThuBoSungHoSo : [],
        // form TTXM
        listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM: donData.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM || [],
        listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView : donData.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView ? donData.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView: [],

        // Thong tin co quan dang giai quyet
        coThongTinCoQuanDangGiaiQuyet: donData.coQuanDangQuyetInfo ? true : false,
        dataCoQuanDangGiaiQuyet: donData.coQuanDangQuyetInfo ? donData.coQuanDangQuyetInfo : {},

        // Thong tin co quan da giai quyet
        coThongTinCoQuanDaGiaiQuyet: donData.coThongTinCoQuanDaGiaiQuyet,
        dataCoQuanDaGiaiQuyet: ((donData.coThongTinCoQuanDaGiaiQuyet && donData.coQuanDaGiaiQuyetDon) ? donData.coQuanDaGiaiQuyetDon : {}),
        lanhDaoDuyet: donData.lanhDaoDuyet,

        // Thong tin giai quyet don get ID
        thongTinGiaiQuyetDonId: donData.thongTinGiaiQuyetDonId,

        dataKetQuaXuLyDon: {
          thamQuyenGiaiQuyet: donData.thamQuyenGiaiQuyetInfo ? donData.thamQuyenGiaiQuyetInfo.ten : ''
        },
        pageLoading: false
      });
      if (donData.thongTinGiaiQuyetDonId) {
        // Lay thong tin giai quyet don Id neu co
        GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: donData.thongTinGiaiQuyetDonId }).then(dataGiaiQuyetDon => {
          if (dataGiaiQuyetDon.data)
            this.setState({
              thongTinGiaiQuyetDonPlus: dataGiaiQuyetDon.data
            })
        })
      }
    }).catch(e => {
      this.setState({pageLoading: false});
    });
  }

  getDetail(inputId) {
    this.setState({pageLoading: true});
    Letter.actions.getDonDetail.request({ id: inputId }).then(res => {
      if (res.data) {
        if (CheckViewPermission(res.data)) {
          this.getDonInfo(res.data);
        } else {
          browserHistory.push('/page-403');
        }
      }
    });
  }

  // Hien thi view NhiemVuTTXM hoac ThongTinYeuCauKTDX
  viewInfomationWork() {
    if (this.state.processTypeValue == 'THAM_TRA_XAC_MINH') {
      switch (this.state.alias) {
        case 'CanBoNhapLieuTTXMAction':
        case 'LanhDaoTTXMAction':
          return (
            <div className="page-wrapper">
              <NhiemVuTTXM
                thongTinGiaiQuyetDonPlus={this.state.thongTinGiaiQuyetDonPlus}
                thongTinXuLyGiaiQuyet={this.state.thongTinXuLyGiaiQuyet}
                listTaiLieuVanThuGiaiQuyetDon={this.state.listTaiLieuVanThuGiaiQuyetDon}
                donInfo = {this.state.data}
              />
            </div>
          )
      }
    } else if (this.state.processTypeValue == 'KIEM_TRA_DE_XUAT') {
      if (this.state.alias == 'canBoKiemTraDeXuat') {
        return (
          <div className="page-wrapper">
            <ThongTinYeuCauKTDX
              thongTinYeuCauKiemTraDeXuat={this.state.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo}
              listTaiLieuVanThuKiemTraDeXuat={this.state.listTaiLieuVanThuKiemTraDeXuat}
              showTable={
                ((this.state.alias == 'vanThuKiemTraDeXuat') ||
                (this.state.alias == 'lanhDaoKiemTraDeXuat')) ||
                (this.state.donDangXuLy && this.state.alias == 'canBoKiemTraDeXuatKhongQuyTrinh')
              }
            />
          </div>
        )
      } else {
        return (
          <div className="page-wrapper">
            <ThongTinYeuCauKTDX
              thongTinYeuCauKiemTraDeXuat={this.state.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo}
              listTaiLieuVanThuKiemTraDeXuat={this.state.listTaiLieuVanThuKiemTraDeXuat}
              showTable={ false}/>
          </div>
        )
      }
    }
  }

  renderForm(donId) {
    // Don dang xu ly thi goi API Current Form
    if (this.state.donDangXuLy) {
      this.getCurrentForm(donId);
    }

    this.getThongTinXuLyHoacGiaiQuyet(donId);
  }

  // Lay thong tin xu ly hoac giai quyet don
  // (1) Neu thong tin xu ly api tra ve khong co thi lay thong tin giai quyet api tra ve
  getThongTinXuLyHoacGiaiQuyet(donId) {

    LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(res => {

      if (res.data) {

        let info = res.data;
        let title = '';

        // Set title cho form xu ly
        if (this.state.donDangXuLy)
          title = 'Thông tin xử lý';
        else {

          // Kiem tra dieu kien hien thi form TU XU LY
          if (CheckQuyenTuXuLy(this.state.quyenTuXuLy) && this.state.typePage == 'xu-ly') {
            title = 'Thông tin xử lý';
          } else {
            title = 'Thông tin đã xử lý';
          }
        }

        this.setState({
          title: title,
          thongTinXuLyGiaiQuyet: info.thongTinXuLyInfo,
          thoiHanBaoCaoKetQuaTTXM: info.thongTinXuLyInfo.thoiHanBaoCaoKetQuaTTXM || ''
        });

        if (!this.state.donDangXuLy) {
          if (CheckQuyenTuXuLy(this.state.quyenTuXuLy) && this.state.typePage == 'xu-ly') {
            this.setState({
              alias: 'XuLyDonTuXuLy',
            });
          } else {
            this.setState({
              alias: info.nextFormInfo.alias,
            });
          }
        }
      }
    }).catch(error => {

      if (error.response) {
        if (CheckQuyenTuXuLy(this.state.quyenTuXuLy) && this.state.typePage == 'xu-ly') {
          this.setState({displayXuLyDon: false});
        } else if (error.response.data.errors[0].code == 'DATA_NOT_FOUND') {
          this.getThongTinGiaiQuyetDon(donId);
        }
      }
    });
  }

  // Neu (1) loi thi lay
  getThongTinGiaiQuyetDon(donId) {

    GiaiQuyetDonThu.actions.getLichSuGiaiQuyetDon.request({ id: donId }).then(res => {
      if (res.data) {

        let info = res.data;
        let title = '';
        let alias = '';
        let processType = '';

        // Set title cho form giai quyet hoac kiem tra de xuat
        if (this.state.donDangXuLy) {

          if (this.state.processTypeValue == 'THAM_TRA_XAC_MINH' || this.state.processTypeValue == 'GIAI_QUYET_DON') {
            if (this.state.alias == 'CanBoTTXMAction')
              title = 'Báo cáo thẩm tra xác minh';
            else
              title = 'Thông tin giải quyết';
          } else if (this.state.processTypeValue == 'KIEM_TRA_DE_XUAT') {
            if (this.state.alias == 'canBoKiemTraDeXuatKhongQuyTrinh') {
              title = 'Báo cáo kết quả kiểm tra';
            } else {
              title = 'Thông tin đề xuất';
            }
          }
          alias = this.state.alias;
          processType = this.state.processTypeValue;
        } else {

          if (info.processType.type == 'KIEM_TRA_DE_XUAT') {

            title = 'Thông tin đã đề xuất';

            if (info.nextFormInfo.alias == 'canBoKiemTraDeXuat' || info.nextFormInfo.alias == 'canBoKiemTraDeXuatKhongQuyTrinh') {

              title = 'Báo cáo kết quả kiểm tra';
            }
          } else {

            if (info.nextFormInfo.alias == 'CanBoGiaiQuyetDonAction' ||
            info.nextFormInfo.alias == 'CanBoGiaiQuyetDonLapDuThaoAction' ||
            info.nextFormInfo.alias == 'CanBoTTXMAction') {
              let lb2 = this.state.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
              title = 'Báo cáo kết quả xác minh'+lb2;
            }
          }

          processType = info.processType.type;
          alias = info.nextFormInfo.alias;
        }
        this.setState({
          alias: alias,
          title: title,
          processTypeValue: processType,
          thongTinXuLyGiaiQuyet: info
        });

        this.state.dataKetQuaXuLyDon.yKienXuLy = res.data.thongTinGiaiQuyetDonInfo.yKienXuLyDon;
        this.state.dataKetQuaXuLyDon.phongBanGiaiQuyet = res.data.phongBanGiaiQuyetInfo.ten;
        this.setState({...this.state});
      }
    }).catch(error => {
      if (error.response) {
      }
    })
  }

  getCurrentForm(donId) {
    LetterProcessingWorkFlow.actions.getCurrentForm.request({ donId: donId }).then(res => {
      if (res.data) {

        let info = res.data;

        this.setState({
          alias: info.currentForm.alias,
          processTypeValue: info.currentForm.processTypeInfo.giaTri,
          listNextStates: info.listNextStates
        })
      }
    }).catch(error => {
      if (error.response) {
      }
    })
  }

  postTuXuLyDon(type) {
    this.setState({isSave: false}, () => {
      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true,
        });
        this.saveTepDinhKem(type, '', () => {
          if (!this.state.params.donViNgoaiHeThongId && this.state.params.donViNgoaiHeThong) {
            Danhmuc.actions.postDonViNgoai.request(null, {ten: this.state.params.donViNgoaiHeThong.trim()}).then(res => {
              if (res.data) {
                this.state.params.donViNgoaiHeThong = {id: res.data.donViNgoaiHeThongId};
                LetterProcessingWorkFlow.actions.postTuXuLyDon.request('', this.state.params).then(res => {
                  this.onClickClose();
                  Toastr(this.state.noticeMsg, 'success');
                }).catch(error => {
                  if (error.response) {
                    Toastr(error.response.data.errors[0].detail, 'error');
                  }
                  this.setState({
                    btnLoading: false,
                  });
                });
              }
            }).catch(error => {
              if (error.response) {
                Toastr(error.response.data.errors[0].detail,'error');
                this.setState({btnLoading: false});
              }
            });
          } else {
            if (this.state.params.donViNgoaiHeThongId) {
              this.state.params.donViNgoaiHeThong = {id: this.state.params.donViNgoaiHeThongId};
            } else {
              this.state.params.donViNgoaiHeThong = null;
            }
            LetterProcessingWorkFlow.actions.postTuXuLyDon.request('', this.state.params).then(res => {
              this.onClickClose();
              Toastr(this.state.noticeMsg, 'success');
            }).catch(error => {
              if (error.response) {
                Toastr(error.response.data.errors[0].detail, 'error');
              }
              this.setState({
                btnLoading: false,
              });
            });
          }
        });
      }
    });
  }

  patchTuXuLyDon(type) {
    this.setState({isSave: true}, () => {

      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });
      this.saveTepDinhKem(type, 'save', () => {
        if (!this.state.params.donViNgoaiHeThongId && this.state.params.donViNgoaiHeThong) {
          Danhmuc.actions.postDonViNgoai.request(null, {ten: this.state.params.donViNgoaiHeThong.trim()}).then(res => {
            if (res.data) {
              this.state.params.donViNgoaiHeThong = {id: res.data.donViNgoaiHeThongId};
              LetterProcessingWorkFlow.actions.patchTuXuLy.request({ id: this.state.donId }, this.state.params).then(res => {
                this.onClickClose();
                Toastr(msg.xldLuu, 'success');
              }).catch(error => {
                if (error.response) {
                  Toastr(error.response.data.errors[0].detail, 'error');
                }
              });
            }
          }).catch(error => {
            if (error.response) {
              Toastr(error.response.data.errors[0].detail,'error');
              this.setState({btnLoading: false});
            }
          });
        } else {
          if (this.state.params.donViNgoaiHeThongId) {
            this.state.params.donViNgoaiHeThong = {id: this.state.params.donViNgoaiHeThongId};
          } else {
            this.state.params.donViNgoaiHeThong = null;
          }
          LetterProcessingWorkFlow.actions.patchTuXuLy.request({ id: this.state.donId }, this.state.params).then(res => {
            this.onClickClose();
            Toastr(msg.xldLuu, 'success');
          }).catch(error => {
            if (error.response) {
              Toastr(error.response.data.errors[0].detail, 'error');
            }
          });
        }
      });
    });
  }

  postXuLyDon(type) {
    this.setState({isSave: false}, () => {
      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true,
        });
        this.saveTepDinhKem(type, 'postXuLyDon', () => {
          if (!this.state.params.donViNgoaiHeThongId && this.state.params.donViNgoaiHeThong) {
            Danhmuc.actions.postDonViNgoai.request(null, {ten: this.state.params.donViNgoaiHeThong.trim()}).then(res => {
              if (res.data) {
                this.state.params.donViNgoaiHeThong = {id: res.data.donViNgoaiHeThongId};
                LetterProcessingWorkFlow.actions.postXuLyDon.request('', this.state.params).then(res => {
                  this.onClickClose();
                  Toastr(this.state.noticeMsg, 'success');
                }).catch(error => {
                  if (error.response) {
                    Toastr(error.response.data.errors[0].detail, 'error');
                  }
                  this.setState({
                    btnLoading: false,
                  });
                });
              }
            }).catch(error => {
              if (error.response) {
                Toastr(error.response.data.errors[0].detail,'error');
                this.setState({btnLoading: false});
              }
            });
          } else {
            if (this.state.params.donViNgoaiHeThongId) {
              this.state.params.donViNgoaiHeThong = {id: this.state.params.donViNgoaiHeThongId};
            } else {
              this.state.params.donViNgoaiHeThong = null;
            }
            LetterProcessingWorkFlow.actions.postXuLyDon.request('', this.state.params).then(res => {
              this.onClickClose();
              Toastr(this.state.noticeMsg, 'success');
            }).catch(error => {
              if (error.response) {
                Toastr(error.response.data.errors[0].detail, 'error');
              }
              this.setState({
                btnLoading: false,
              });
            });
          }
        });
      }
    });
  }
  patchXuLyDon(type) {
    this.setState({isSave: true}, () => {
      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });
      this.saveTepDinhKem(type, 'save', () => {
        if (!this.state.params.donViNgoaiHeThongId && this.state.params.donViNgoaiHeThong) {
          Danhmuc.actions.postDonViNgoai.request(null, {ten: this.state.params.donViNgoaiHeThong.trim()}).then(res => {
            if (res.data) {
              this.state.params.donViNgoaiHeThong = {id: res.data.donViNgoaiHeThongId};
              LetterProcessingWorkFlow.actions.patchXuLyDon.request({ id: this.state.donId }, this.state.params).then(res => {
                this.onClickClose();
                Toastr(msg.xldLuu, 'success');
              }).catch(error => {
                if (error.response) {
                  Toastr(error.response.data.errors[0].detail, 'error');
                }
              });
            }
          });
        } else {
          if (this.state.params.donViNgoaiHeThongId) {
            this.state.params.donViNgoaiHeThong = {id: this.state.params.donViNgoaiHeThongId};
          } else {
            this.state.params.donViNgoaiHeThong = null;
          }
          LetterProcessingWorkFlow.actions.patchXuLyDon.request({ id: this.state.donId }, this.state.params).then(res => {
            this.onClickClose();
            Toastr(msg.xldLuu, 'success');
          }).catch(error => {
            if (error.response) {
              Toastr(error.response.data.errors[0].detail, 'error');
            }
          });
        }
      });
    });
  }

  postGiaiQuyetDon() {

    if (this.validateSubmitForm()) {
      this.setState({
        btnLoading: true
      });

      let paramsPost = this.state.params.paramsPost;

      paramsPost.thongTinGiaiQuyetDon = {
        id: this.state.data.thongTinGiaiQuyetDonId
      }

      // if (this.state.alias == 'CanBoTTXMAction' || this.state.alias == 'CanBoTTXMKhongQuyTrinh')
      this.saveTepDinhKem('', '', () => {
        GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', paramsPost).then(res => {
          this.onClickClose();
          Toastr(this.state.noticeMsg, 'success');
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail, 'error');
          }
        });
      });
    }
  }

  patchGiaiQuyetDon(isPost = true) {
    this.setState({isSave: !isPost}, () => {
      if (!isPost || this.validateSubmitForm()) {
        if (!isPost) {
          this.setState({
            btnSaveLoading: true
          });
        }

        let paramsPatch = ConvertParams(this.state.params.paramsPatch, this.state.donId);

        // if (this.state.alias == 'CanBoTTXMAction' || this.state.alias == 'CanBoTTXMKhongQuyTrinh')
        this.saveTepDinhKem('', '', () => {
          GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({ id: this.state.thongTinGiaiQuyetDonId }, paramsPatch).then(res => {
            if (!isPost) {
              this.onClickClose();
              Toastr(msg.gqdLuu, 'success');
            } else {
              this.postGiaiQuyetDon();
            }
          }).catch(error => {
            if (error.response) {
              Toastr(error.response.data.errors[0].detail, 'error');
            }
          });
        });
      }
    });
  }

  compareDate(firstDate, secondDate, type) {
    var firstTime = firstDate.getTime();
    var secondTime = secondDate.getTime()

    if (firstTime > secondTime || (firstTime == secondTime && type == 'show')) {
      return true
    } else {
      return false
    }
  }

  saveTepDinhKem(type, action, callback) {
    this.setState({
      btnLoading: true,
      btnSaveLoading: true
    });

    this.state.dataFileDinhKem.map((item, i) => {

      if (item.taiLieuVanThuId) {
        this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
          don: {
            id: Number(this.state.donId)
          },
          id: item.taiLieuVanThuId,
          ten: item.ten,
          soQuyetDinh: item.soQuyetDinh,
          ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
          tenFile: item.tenFile,
          duongDan: item.duongDan,
          loaiTepDinhKem: item.loaiTepDinhKem,
          loaiQuyTrinh: item.loaiQuyTrinh,
          buocGiaiQuyet: null,
          required: item.required,
          typeRequired: item.typeRequired ? item.typeRequired : ''
        };
      } else {
        this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
          don: {
            id: Number(this.state.donId)
          },
          ten: item.ten,
          soQuyetDinh: item.soQuyetDinh,
          ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
          tenFile: item.tenFile,
          duongDan: item.duongDan,
          loaiTepDinhKem: this.state.loaiTepDinhKem,
          loaiQuyTrinh: this.state.loaiQuyTrinh,
          buocGiaiQuyet: null,
          required: item.required,
          typeRequired: item.typeRequired ? item.typeRequired : ''
        };
      }
    });

    if (type == 'BC_XLD') {
      let dataFilter = [];
      let dataInit = [...this.state.initTaiLieuVanThu];
      let data = [];
      if (this.state.data.ngayTraTTXMKhongDungThamQuyen) {
        data = dataInit.filter(state => {
          return this.compareDate(new Date(state.ngayTao), new Date(this.state.data.ngayTraTTXMKhongDungThamQuyen), 'action');
        })
      } else if(this.state.data.ngayNhanDon) {
        data = dataInit.filter(state => {
          return this.compareDate(new Date(state.ngayTao), new Date(this.state.data.ngayNhanDon), 'action');
        })
      } else {
        data = [...dataInit]
      }
      if (this.state.params && this.state.params.huongXuLy == 'DE_XUAT_THU_LY') {
        if (this.state.params && this.state.params.trangThaiTTXM == 'GIAO_TTXM') {
          if (this.state.data.donGocId) {
            dataFilter = data.filter(item => {
              return item.required && (item.typeRequired != 'XLD_PCD' && item.typeRequired != 'XLD_GTTXM' && item.typeRequired != 'XLD_PDXTL' && item.typeRequired != '' && item.typeRequired != null)
            })
          } else {
            dataFilter = data.filter(item => {
              return item.required && (item.typeRequired != 'XLD_GTTXM' && item.typeRequired != 'XLD_PDXTL' && item.typeRequired != '' && item.typeRequired != null)
            })
          }
        } else {
          if (this.state.data.donGocId) {
            dataFilter = data.filter(item => {
              return item.required && (item.typeRequired != 'XLD_PCD' && item.typeRequired != 'XLD_PDXTL' && item.typeRequired != '' && item.typeRequired != null)
            })
          } else {
            dataFilter = data.filter(item => {
              return item.required && (item.typeRequired != 'XLD_PDXTL' && item.typeRequired != '' && item.typeRequired != null)
            })
          }
        }
      } else if (this.state.params && this.state.params.huongXuLy == 'KHONG_DU_DIEU_KIEN_THU_LY') {
        dataFilter = data.filter(item => {
          return (item.required && (item.typeRequired != 'XLD_KDDKTL' && item.typeRequired != '' && item.typeRequired != null)) || (!item.required && item.typeRequired == 'XLD_PDXTL')
        })
      } else if (this.state.params && this.state.params.huongXuLy == 'CHUYEN_DON') {
        dataFilter = data.filter(item => {
          return (item.required && (item.typeRequired != 'XLD_PCD' && item.typeRequired != '' && item.typeRequired != null)) || (!item.required && item.typeRequired == 'XLD_PDXTL')
        })
      } else if (this.state.params && this.state.params.huongXuLy == 'TRA_DON_VA_HUONG_DAN') {
        dataFilter = data.filter(item => {
          return (item.required && (item.typeRequired != 'XLD_TDHD' && item.typeRequired != '' && item.typeRequired != null)) || (!item.required && item.typeRequired == 'XLD_PDXTL')
        })
      } else if (this.state.params && this.state.params.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN') {
        dataFilter = data.filter(item => {
          return (item.required && (item.typeRequired != 'XLD_TDKDTQ' && item.typeRequired != '' && item.typeRequired != null)) || (!item.required && item.typeRequired == 'XLD_PDXTL')
        })
      } else {
        dataFilter = data.filter(item => {
          return (item.required && (item.typeRequired != '' || item.typeRequired != null)) || (!item.required && item.typeRequired == 'XLD_PDXTL')
        })
      }
      if (dataFilter.length > 0) {
        if ((this.state.params.huongXuLy === 'DE_XUAT_THU_LY' || this.state.params.huongXuLy === 'CHUYEN_DON') && (action === 'save' || action === 'postXuLyDon')) {
          const listIdDelete = [];
          if (!isEmpty(this.state.taiLieuVanThu)) {
            dataFilter.forEach(item => {
              this.state.taiLieuVanThu.forEach(taiLieu => {
                if (item.donId === taiLieu.don.id) {
                  listIdDelete.push({
                    id: item.taiLieuVanThuId
                  })
                }
              })
            })
          }
          this.setState({
            taiLieuVanThuDelete: listIdDelete
          })
        } else {
          dataFilter.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }
      }

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }
      this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
        this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
          this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
            callback();
          });
        });
      });
    } else {
      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
        this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
          this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
            callback();
          });
        });
      });
    }

  }

  // Cap nhat tep dinh kem
  updateTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Them tep dinh kem
  postTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Xoa tep dinh kem
  deleteTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Thay doi tep dinh kem
  onChangeTepDinhKem(tepDinhKem, deleteTepDinhKem, loaiQuyTrinh, loaiTepDinhKem) {
    this.setState({
      loaiQuyTrinh: loaiQuyTrinh,
      loaiTepDinhKem: loaiTepDinhKem,
      dataFileDinhKem: tepDinhKem,
      dataTaiLieuVanThuDelete: deleteTepDinhKem
    })
  }

  // In phieu
  inPhieu(loaiPhieu) {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let URL = String(API_URL);
    let thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;
    let loaiDon = this.state.loaiDon;
    let ngayTiepNhan = moment(this.state.ngayTiepNhan).format('DD/MM/YYYY');
    let nguoiDungDon = this.state.dataNguoiDungDon[0];
    let diaChiNguoiDungDon = '';
    let ngayCap = moment(nguoiDungDon.ngayCap).format('DD/MM/YYYY') == 'Invalid date' ? (nguoiDungDon.ngayCap || '') : moment(nguoiDungDon.ngayCap).format('DD/MM/YYYY');
    let noiCapCMND = nguoiDungDon.noiCapCMNDInfo ? nguoiDungDon.noiCapCMNDInfo.ten : '';
    let cqTiepNhan = userInfo.tenCoQuanQuanLy;
    let donViTiepNhanDonId= '';
    if (loaiPhieu == 'CHUYEN_DON') {
      if (this.state.params.thamQuyenGiaiQuyet) {
        if (this.state.params.thamQuyenGiaiQuyet.id == thamQuyenHanhChinhId) {
          cqTiepNhan = this.state.params.coQuanTiepNhan.ten;
          donViTiepNhanDonId = this.state.params.coQuanTiepNhan.id;
        } else {
          cqTiepNhan = this.state.params.donViNgoaiHeThong;
        }
      } else {
        cqTiepNhan = '';
      }
    }
    if (nguoiDungDon.diaChi)
      diaChiNguoiDungDon = diaChiNguoiDungDon + nguoiDungDon.diaChi + ', ';

    if (nguoiDungDon.toThon)
      diaChiNguoiDungDon = diaChiNguoiDungDon + nguoiDungDon.toThon + ', ';

    if (nguoiDungDon.phuongXaCongDan)
      diaChiNguoiDungDon = diaChiNguoiDungDon + nguoiDungDon.phuongXaCongDan.ten + ', ';

    if (nguoiDungDon.quanHuyenCongDan)
      diaChiNguoiDungDon = diaChiNguoiDungDon + nguoiDungDon.quanHuyenCongDan.ten + ', ';

    if (nguoiDungDon.tinhThanhCongDan)
      diaChiNguoiDungDon = diaChiNguoiDungDon + nguoiDungDon.tinhThanhCongDan.ten + ', ';

    diaChiNguoiDungDon = diaChiNguoiDungDon.slice(0, diaChiNguoiDungDon.length - 2);

    let noiDung = this.state.noiDung;
    let coQuanChuyenDon = this.state.thongTinXuLyGiaiQuyet && this.state.thongTinXuLyGiaiQuyet.coQuanChuyenDon ? this.state.thongTinXuLyGiaiQuyet.coQuanChuyenDon.ten : '';
    switch (loaiPhieu) {
      case "THU_LY":

        URL = URL + "/xuLyDons/inPhieuDeXuatThuLy?"
          + "loaiDon=" + loaiDon
          + "&ngayTiepNhan=" + ngayTiepNhan
          + "&nguoiDungDon=" + nguoiDungDon.hoVaTen
          + "&diaChi=" + diaChiNguoiDungDon
          + "&donViXuLyId=" + userInfo.donViId
          + "&coQuanTiepNhan=" + cqTiepNhan
          + "&soCMNDHoChieu=" + nguoiDungDon.soCMNDHoChieu
          + "&ngayCap=" + ngayCap
          + "&noiCap=" + noiCapCMND
          + "&noiDung=" + noiDung;
        window.open(URL, "_self");
        return;

      case "DU_THAO_THONG_BAO_THU_LY":

        if (this.state.loaiDonGiaTri == 'DON_KHIEU_NAI') {
          URL = URL + "/xuLyDons/inPhieuDuThaoThongBaoThuLyKhieuNai?"
            + "ngayTiepNhan=" + ngayTiepNhan
            + "&nguoiKhieuNai=" + nguoiDungDon.hoVaTen
            + "&diaChiNguoiKhieuNai=" + diaChiNguoiDungDon
            + "&SoCMNDHoChieu=" + nguoiDungDon.soCMNDHoChieu
            + "&ngayCap=" + ngayCap
            + "&noiCap=" + noiCapCMND
            + "&noiDungKhieuNai=" + noiDung
            + "&donViXuLyId=" + userInfo.donViId
            + "&coQuanTiepNhan=" + cqTiepNhan;

        } else if (this.state.loaiDonGiaTri == 'DON_TO_CAO') {

          URL = URL + "/xuLyDons/inPhieuDuThaoThongBaoThuLyGQTC?"
            + "doiTuongGiaiQuyet=" + this.state.dataCoQuanDangGiaiQuyet.ten
            + "&nguoiDungDon=" + nguoiDungDon.hoVaTen
            + "&donId=" + this.state.donId
            + "&donViXuLyId=" + userInfo.donViId
            + "&doiTuongBiToCao=" + this.state.loaiDoiTuong.ten
            + "&noiDungToCao=" + noiDung;

        }
        window.open(URL, "_self");
        return;

      case "CHUYEN_DON":
        if (cqTiepNhan) {
          this.setState({isSave: true});
          if (this.state.loaiDonGiaTri == 'DON_TO_CAO') {
            URL = URL + "/xuLyDons/inPhieuChuyenDonToCao?"
              + "&ngayTiepNhan=" + ngayTiepNhan
              + "&nguoiDungDon=" + nguoiDungDon.hoVaTen
              + "&diaChiNguoiDungDon=" + diaChiNguoiDungDon
              + "&noiDung=" + noiDung
              + "&donViXuLyId=" + userInfo.donViId
              + "&coQuanTiepNhan=" + cqTiepNhan
              + "&donViTiepNhanDonId=" + donViTiepNhanDonId
              + "&coQuanChuyenDon=" + userInfo.tenCoQuanQuanLy;
          } else if (this.state.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
            URL = URL + "/xuLyDons/inPhieuChuyenDonKienNghiPhanAnh?"
              + "ngayTiepNhan=" + ngayTiepNhan
              + "&nguoiDungDon=" + nguoiDungDon.hoVaTen
              + "&diaChiNguoiDungDon=" + diaChiNguoiDungDon
              + "&noiDung=" + noiDung
              + "&soCMNDHoChieu=" + nguoiDungDon.soCMNDHoChieu
              + "&ngayCap=" + ngayCap
              + "&noiCap=" + noiCapCMND
              + "&donViXuLyId=" + userInfo.donViId
              + "&coQuanTiepNhan=" + cqTiepNhan
              + "&coQuanChuyenDon=" + userInfo.tenCoQuanQuanLy;
          }
          window.open(URL, "_self");
        } else {
          Toastr('Vui lòng chọn cơ quan tiếp nhận', 'warning');
        }

        return;

      case "KHONG_DU_DIEU_KIEN_THU_LY_KHIEU_NAI":
        let apiPrint = "/xuLyDons/inPhieuKhongDuDieuKienThuLyKhieuNai?";
        if (this.state.loaiDonGiaTri == 'DON_TO_CAO') {
          apiPrint = "/xuLyDons/inPhieuKhongDuDieuKienThuLyToCao?";
        } else if (this.state.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
          apiPrint = "/xuLyDons/inPhieuKhongDuDieuKienThuLyKienNghi?";
        }

        URL = URL + apiPrint
          + "&ngayTiepNhan=" + ngayTiepNhan
          + "&nguoiDungDon=" + nguoiDungDon.hoVaTen
          + "&nguoiToCao=" + nguoiDungDon.hoVaTen
          + "&nguoiKienNghi=" + nguoiDungDon.hoVaTen
          + "&diaChiNguoiDungDon=" + diaChiNguoiDungDon
          + "&diaChiNguoiToCao=" + diaChiNguoiDungDon
          + "&diaChiNguoiKienNghi=" + diaChiNguoiDungDon
          + "&noiDung=" + noiDung
          + "&donId=" + this.state.donId
          + "&soCMNDHoChieu=" + nguoiDungDon.soCMNDHoChieu
          + "&ngayCap=" + ngayCap
          + "&noiCap=" + noiCapCMND
          + "&donViXuLyId=" + userInfo.donViId
          + "&lyDo=" + this.state.params.yKienXuLy
          + "&lyDoDinhChi=" + this.state.params.yKienXuLy
          + "&coQuanTiepNhan=" + cqTiepNhan;

        window.open(URL, "_self");
        return;

      case "HUONG_DAN":
        apiPrint = "/xuLyDons/inPhieuTraDonVaHuongDanKhieuNai?";
        if (this.state.loaiDonGiaTri == 'DON_TO_CAO') {
          apiPrint = "/xuLyDons/inPhieuHuongDanToCao?";
        }
        URL = URL + apiPrint
          + "&ngayTiepNhan=" + ngayTiepNhan
          + "&nguoiDungDon=" + nguoiDungDon.hoVaTen
          + "&hoVaTen=" + nguoiDungDon.hoVaTen
          + "&soCMNDHoChieu=" + nguoiDungDon.soCMNDHoChieu
          + "&soCMND=" + nguoiDungDon.soCMNDHoChieu
          + "&diaChi=" + diaChiNguoiDungDon
          + "&ngayCap=" + ngayCap
          + "&noiCap=" + noiCapCMND
          + "&noiDung=" + noiDung
          + "&donViXuLyId=" + userInfo.donViId
          + "&coQuanTiepNhan=" + cqTiepNhan;
        window.open(URL, "_self");
        return;

      case "HUONG_DAN_DON_KIEN_NGHI_PHAN_ANH":
        apiPrint = "/xuLyDons/inPhieuHuongDanKienNghi?";
        URL = URL + apiPrint
          + "&ngayTiepNhan=" + ngayTiepNhan
          + "&hoVaTen=" + nguoiDungDon.hoVaTen
          + "&diaChi=" + diaChiNguoiDungDon
          + "&noiDung=" + noiDung
          + "&donViXuLyId=" + userInfo.donViId;
        window.open(URL, "_self");
        return;

      case "TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN":

        URL = URL + "/xuLyDons/inPhieuTraDonChuyenKhongDungThamQuyen?"
          + "loaiDon=" + loaiDon
          + "&coQuanNhanDon=" + this.state.dataCoQuanDangGiaiQuyet.ten
          + "&coQuanChuyenDon=" + coQuanChuyenDon
          + "&hoTenNguoiCoDon=" + nguoiDungDon.hoVaTen
          + "&ngayTiepNhan=" + ngayTiepNhan
          + "&noiDung=" + noiDung
          + "&donViXuLyId=" + userInfo.donViId
          + "&diaChi=" + diaChiNguoiDungDon;
        window.open(URL, "_self");
        return;

      case "PHIEU_GIAO_NHIEM_VU_TTXM" :
        apiPrint = "/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhKhieuNai?";
        if (this.state.loaiDonGiaTri == 'DON_TO_CAO') {
          apiPrint = "/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhToCao?";
        } else if (this.state.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
          apiPrint = "/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhKienNghi?";
        }

        URL = URL + apiPrint
          + "tenCoQuanThuLyGQKN=" + (this.state.dataCoQuanDangGiaiQuyet ? this.state.dataCoQuanDangGiaiQuyet.ten : '')
          + "&tenCoQuan=" + this.state.dataCoQuanDangGiaiQuyet.ten
          + "&ngayTiepNhan=" + ngayTiepNhan
          + "&diaChi=" + diaChiNguoiDungDon
          + "&tenCoQuanDuocGiaoNhiemVuXM=" + (this.state.params.donViThamTraXacMinhTen ? this.state.params.donViThamTraXacMinhTen : '..........')
          + "&hoTenNguoiKhieuNai=" + nguoiDungDon.hoVaTen
          + "&hoTenNguoiKienNghi=" + nguoiDungDon.hoVaTen
          + "&thoiGianBaoCaoKetQuaTTXM=" + (this.state.params.thoiHanBaoCaoKetQuaTTXM ? moment(this.state.params.thoiHanBaoCaoKetQuaTTXM).format('DD/MM/YYYY') : '')
          + "&donViXuLyId=" + userInfo.donViId
          + "&donId=" + this.state.donId
          + "&noiDungDonThu=" + noiDung
          + "&noiDungTTXM=" + noiDung;
        window.open(URL, "_self");
        return;
    }
  }

  validateThongTinNguoiDungDon() {
    const dataDon = this.state.data;
    if (dataDon.nguonTiepNhanDonInfo && dataDon.listNguoiDungDon && dataDon.listNguoiDungDon.length) {
      return true;
    }
    return false;
  }

  validateThongTinDon() {
    const dataDon = this.state.data;
    let noiDung = dataDon.noiDung;
    if (typeof noiDung === 'string' || noiDung instanceof String) {
      noiDung = noiDung.trim();
    }
    if (dataDon.loaiDonInfo && dataDon.linhVucDonThuDon && noiDung && dataDon.listTaiLieuBangChung && dataDon.listTaiLieuBangChung.length) {
      return true;
    }
    return false;
  }

  validateSubmitForm() {
    let pass = true;
    if (this.validateThongTinNguoiDungDon() === false || this.validateThongTinDon() === false) {
      this.setState({
        dialogConfirm: true,
        dialogConfirmContent: 'Vui lòng kiểm tra lại thông tin đơn.'
      });
      pass = false;
    }

    if (typeof this.props.validators['formTaoDon'] != 'undefined') {
      this.props.validators['formTaoDon'].map(validator => {
        if (pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
        if (!validator.validate() && get(validator, 'props.checkValid')) {
          pass = true;
        }
      });
    }
    return pass;
  }

  componentWillUnmount() {

  }

  handleBack(allowBack) {
    if (allowBack) {
      this.onClickClose();
    } else {
      if (this.state.hasChange) {
        this.state.backConfirm = true;
        this.setState({...this.state});
      } else {
        this.onClickClose();
      }
    }
  }

  toggleDialog(name, status) {
    this.setState({[name]: status});
  }

  onConfirmDelete() {
    let linkToProcessPage = `/xu-ly-don/chinh-sua/${this.state.donId}`;
    browserHistory.push(linkToProcessPage);
  }

  closeConfirmBack() {
    this.state.backConfirm = false;
    this.setState({...this.state});
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>

      <div>
        { this.state.displayXuLyDon ?
            <div id="page" className="panel-page document-detail-page">
              <ConfirmDialog open={this.state.dialogConfirm} onClose={this.toggleDialog.bind(this, 'dialogConfirm', false)} onSuccess={this.onConfirmDelete.bind(this)} title={this.state.dialogConfirmContent} />
              <ConfirmDialog open={this.state.backConfirm} onClose={this.closeConfirmBack.bind(this)} onSuccess={this.handleBack.bind(this, true)} title={msg.confirmBack} />
              {
                this.state.pageLoading ?
                  <Loading/>
                : ''
              }
              <div className={`center ${this.state.pageLoading ? 'hidden' : ''}`}>
                <div className="back-foward">
                  <Link onClick={this.handleBack.bind(this, false)} title="" >Về trang trước</Link>
                </div>
                <div className="heading">
                  <h2 className="heading-title icon-detail">Chi tiết đơn/ vụ việc</h2>
                </div>
                <div className="page-wrapper">
                  <LetterInformation
                    parent={this.state}
                    donId={this.state.donId}
                    typePage={this.state.typePage}
                    thongTinGiaiQuyetDonId={this.state.thongTinGiaiQuyetDonId}
                    thongTinGiaiQuyetDonPlus={this.state.thongTinGiaiQuyetDonPlus} />
                </div>
                <LetterHistory donId={this.props.params.id} ma={this.state.ma} />
                { (this.state.alias == 'CanBoGiaiQuyetDonAction' ||
                  this.state.alias == 'CanBoGiaiQuyetDonLapDuThaoAction' ||
                  this.state.alias == 'CanBoGiaiQuyetDonLapDuThaoKhongQuyTrinh' ||
                  this.state.alias == 'CanBoGiaiQuyetDonKhongQuyTrinh') ?
                    <div className="page-wrapper">
                      <KetQuaXuLyDon status={false}
                        {...this.state.dataKetQuaXuLyDon}
                        donInfo={this.state.data}
                        dataGiaiQuyet = {this.state.thongTinXuLyGiaiQuyet}
                        hideBorder={true}
                      />
                    </div>
                  : ''
                }
                {this.viewInfomationWork()}
                { (this.state.donDangXuLy && CheckQuyenThaoTacXuLy(this.state.canBoDangXuLy)) ||
                  (!this.state.donDangXuLy && (this.state.alias || this.state.trangThaiDonDonVi.ketQuaType == 'DINH_CHI')) ?
                    <div className="page-wrapper">
                      <FormXuLyHoacGiaiQuyet
                        ma={this.state.ma}
                        lyDoDinhChi={this.state.lyDoDinhChi}
                        loaiDonGiaTri={this.state.loaiDonGiaTri}
                        onChangeTepDinhKem={this.onChangeTepDinhKem.bind(this)}
                        thongTinXuLyGiaiQuyet={this.state.thongTinXuLyGiaiQuyet}
                        thongTinYeuCauKiemTraDeXuat={this.state.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo}
                        title={this.state.title}
                        alias={this.state.alias}
                        donId={this.props.params.id}
                        listNextStates={this.state.listNextStates}
                        onChange={this.handleDataForm.bind(this)}
                        onInit={this.handleInitForm.bind(this)}
                        donDangXuLy={this.state.donDangXuLy}
                        tongSoLuotTCD={this.state.tongSoLuotTCD}
                        thongTinGiaiQuyetDonId={this.state.thongTinGiaiQuyetDonId}
                        processType={this.state.processTypeValue}
                        listTaiLieuVanThu={this.state.listTaiLieuVanThu}
                        listTaiLieuVanThuKiemTraDeXuat={this.state.listTaiLieuVanThuKiemTraDeXuat}
                        listTaiLieuVanThuGiaiQuyetDon={this.state.listTaiLieuVanThuGiaiQuyetDon}
                        listTaiLieuVanThuGiaiQuyetDonView={this.state.listTaiLieuVanThuGiaiQuyetDonView}
                        listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM={this.state.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
                        listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView={this.state.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                        listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.state.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
                        listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.state.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
                        listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.state.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
                        listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.state.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
                        listTaiLieuVanThuBoSungHoSo = {this.state.listTaiLieuVanThuBoSungHoSo}
                        thongTinGiaiQuyetDonPlus={this.state.thongTinGiaiQuyetDonPlus}
                        listTaiLieuVanThuChuyenDonBoSungHoSo={this.state.listTaiLieuVanThuChuyenDonBoSungHoSo}
                        inPhieu={this.inPhieu.bind(this)}
                        trangThaiDonDonVi={this.state.trangThaiDonDonVi}
                        bindValidator={this}
                        donInfo={this.state.data}
                        onSave={this.state.isSave}
                        data = {this.state.data}
                        thuHoi = {this.props.thuHoi}
                        pageType="CHI_TIET_DON"/>
                    </div>
                  :''
                }
              </div>
              <div className={((this.state.alias == 'canBoTDTHKhongQuyTrinh' || this.state.alias == 'LanhDaoTDTHAction' || this.state.alias == 'CanBoNhapLieuTDTHAction' || this.state.alias == 'CanBoTTXMKhongQuyTrinh' || this.state.alias == 'CanBoTTXMAction' || this.state.alias == 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoKhongQuyTrinh' || this.state.alias == 'CanBoGiaiQuyetDonLapDuThaoKhongQuyTrinh' || this.state.alias == 'CanBoTTXMChuyenDuThaoKhongQuyTrinh' || this.state.alias == 'canBoKiemTraDeXuatKhongQuyTrinh' || (this.state.alias == 'CanBoGiaiQuyetDonKhongQuyTrinh' && CheckQuyenThaoTacXuLy(this.state.canBoDangXuLy))) && (this.state.donDangXuLy)) ? "center mb100 mt30" : "center mb30 mt30"}>
                <ShowIf condition = {(
                  this.state.alias != 'canBoTDTHKhongQuyTrinh' &&
                  this.state.alias != 'LanhDaoTDTHAction' &&
                  this.state.alias != 'CanBoNhapLieuTDTHAction' &&
                  this.state.alias != 'CanBoTTXMKhongQuyTrinh' &&
                  this.state.alias != 'CanBoTTXMAction' &&
                  this.state.alias != 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoKhongQuyTrinh' &&
                  this.state.alias != 'CanBoGiaiQuyetDonLapDuThaoKhongQuyTrinh' &&
                  this.state.alias != 'CanBoGiaiQuyetDonKhongQuyTrinh' &&
                  this.state.alias != 'canBoKiemTraDeXuatKhongQuyTrinh' &&
                  this.state.alias != 'CanBoTTXMChuyenDuThaoKhongQuyTrinh'
                  ) || (
                    this.state.alias == 'CanBoGiaiQuyetDonKhongQuyTrinh' &&
                    !CheckQuyenThaoTacXuLy(this.state.canBoDangXuLy)
                  ) || !this.state.donDangXuLy
                }>
                  <ButtonGroup
                    canBoDangXuLy={this.state.canBoDangXuLy}
                    trangThaiDonDonVi={this.state.trangThaiDonDonVi}
                    pageType="CHI_TIET_DON"
                    alias={this.state.alias}
                    donId={this.state.donId}
                    lanhDaoDuyet={this.state.lanhDaoDuyet}
                    donInfo={this.state.data}
                    onClose={this.handleBack.bind(this, false)}
                    onClickXuLyDon={this.postXuLyDon.bind(this)}
                    onClickGiaiQuyet={this.patchGiaiQuyetDon.bind(this,true)}
                    onClickSaveFile={this.saveTepDinhKem.bind(this, '')}
                    onClickTuXuLy={this.postTuXuLyDon.bind(this)}
                    patchTuXuLy={this.patchTuXuLyDon.bind(this)}
                    patchXuLyDon={this.patchXuLyDon.bind(this)}
                    patchGiaiQuyetDon={this.patchGiaiQuyetDon.bind(this,false)}
                    params={this.state.params}
                    donDangXuLy={this.state.donDangXuLy}
                    processType={this.state.processTypeValue}
                    btnLoading={this.state.btnLoading}
                    btnSaveLoading={this.state.btnSaveLoading}
                    validateSubmitForm={this.validateSubmitForm.bind(this)}
                    bindValidator={this}
                    thongTinXuLyGiaiQuyet={this.state.thongTinXuLyGiaiQuyet}
                    onChange={this.handleDataForm.bind(this)}/>
                </ShowIf>
              </div>
            </div>
          :
            <TuGiaiQuyetDon params={{id: this.props.params.id}} fromXLD={true}/>
        }
      </div>
      </MasterLayout>
    );
  }
}

HandleLettersDetails.defaultProps = {
  validators: []
}

export default connect()(HandleLettersDetails);



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/detail-handle-letters/HandleLettersDetails.jsx